/**
 * API service for fetching job roles
 */
import axios from "../utils/api-client";

export interface JobRole {
	id: number
	name: string
	hexColor: string
	isActive: boolean
	workCenterIds?: string
	skills?: Array<{
		id: number
		jobId: number
		name: string
		skillId: number
	}>
}

export interface JobRoleColorMap {
	[jobRoleName: string]: string
}

const API_BASE_URL = process.env.REACT_APP_API_END_POINT;

export const jobsApi = {
	/**
	 * Get all job roles for a user
	 * @param userId - The user ID to fetch job roles for
	 */
	getAll: async (userId: string): Promise<JobRole[]> => {
		const response = await axios.get<JobRole[]>(
			`${API_BASE_URL}/Jobs/GetJobsByUser`,
			{
				params: { userid: userId },
			}
		);
		return response.data;
	},

	/**
	 * Get a color map from job role names to hex colors
	 * Useful for quick color lookups by name
	 * @param userId - The user ID to fetch job roles for
	 */
	getColorMap: async (userId: string): Promise<JobRoleColorMap> => {
		const jobRoles = await jobsApi.getAll(userId);
		const colorMap: JobRoleColorMap = {};
		jobRoles.forEach((job) => {
			// Store with # prefix for direct use
			colorMap[job.name] = `#${job.hexColor}`;
		});
		return colorMap;
	},
};

export default jobsApi;

